import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';

import { pageChanged } from '../../../../../../data/redux/page_details/actions';
import { getAgentProfileDetails, updateAgent, getAllAgents } from '../../../../../../data/redux/member_details/actions';

import { APP_PAGES, APP_LAYOUT, ROUTE_PATH, TYPES } from '../../../../../../data/config/constants';
import { getUrlParams, showMessage } from '../../../../../../data/config/utils';

import CustomHeader from '../../../../../../components/customheader';
import AgentProfileCard from '../components/agentprofilecard';
import ErrorBoundary from '../../../../../../components/errorboundary';
import AgentForm from '../components/agentform';

class EditAgentProfile extends React.PureComponent {
  state = {
    agent: {}
  };

  componentDidMount() {
    const { actions, agents } = this.props;
    actions.pageChanged(APP_PAGES.EDIT_AGENT_PROFILE, APP_PAGES.MEMBERS);
    if (agents.length === 0) {
      actions.getAllAgents();
    }
    const params = getUrlParams();
    if (params && params.email) {
      const payload = { email: params.email };
      actions.getAgentProfileDetails(payload, (error, agent) => {
        if (!error) {
          this.setState({ agent });
        } else {
          this.goBackToAgents();
        }
      });
    } else {
      showMessage('error', 'email is missing in params');
      this.goBackToAgents();
    }
  }

  goBackToAgents = () => {
    const { history } = this.props;
    history.push(ROUTE_PATH.AGENTS);
  };

  onChangeAgent = (key, value) => {
    this.setState({
      agent: {
        ...this.state.agent,
        [key]: value
      }
    });
  };

  updateAgentProfile = () => {
    const { agent } = this.state;
    if (agent.email) {
      const payload = {
        email: agent.email,
        updates: agent
      };
      this.props.actions.updateAgent(payload, this.goBackToAgents);
    } else {
      showMessage('error', 'email is missing');
      this.goBackToAgents();
    }
  };

  render() {
    const { screen_height, agents } = this.props;
    const { agent } = this.state;

    return (
      <div className="ori-lr-pad-10">
        <Row gutter={20}>
          <Col xs={24} sm={16} md={18}>
            <CustomHeader title="Edit Agent Profile" first_button_type="primary" onClickFirstButton={this.updateAgentProfile} onClickSecondButton={this.goBackToAgents} bottom_bordered show_first_button show_second_button />
            <Row>
              <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 16, offset: 4 }}>
                <ErrorBoundary type={TYPES.ERROR} handleButtonClick={this.goBackToAgents} show_button>
                  <AgentForm agent={agent} agents={agents} onChange={this.onChangeAgent} />
                </ErrorBoundary>
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={8} md={6} className="ori-t-pad-20 ori-b-pad-15 ori-l-pad-5 ori-overflow-x-hidden ori-overflow-y-auto" style={{ height: `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT}px` }}>
            <AgentProfileCard agent={agent} />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    screen_height: state.page_details.device_data.screen_height,
    agents: state.member_details.agents,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ pageChanged, getAgentProfileDetails, updateAgent, getAllAgents }, dispatch),
  };
};

EditAgentProfile.propTypes = {
  screen_height: PropTypes.number,
  agents: PropTypes.array,
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(EditAgentProfile);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/agents/editagentprofile/index.js